import CookieConsent from './CookieConsent';

const modules = [
    CookieConsent
  ],

  RailsApp = {
    run: () => {
      modules.forEach(Module => {
        (new Module()).init();
      });
    }
  };

export default RailsApp;
